// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"de1d02e1474529d8","5763":"f394f5abb85f01f6","6893":"113100b26e79c8aa","6974":"36addf2c0334116e","7222":"f6a828fb9f5eb157","7937":"6d15ebc388ef163f"}[chunkId] + ".js";
};